import React, { memo } from 'react';
import { useWindowSize } from 'react-use';

import { type NearbyStation } from 'types/buoys';
import config from '../../config';
import BuoyVirtualList from './BuoyVirtualList';

import styles from './MapBuoyCards.module.scss';

interface Props {
  /*
    TODO: remove any when we have consistent typing between buoys proptypes and
    buoys ts files. Currently the worst discrpancy is the StationData values which can either be
    numbers or null in our ts files but are required to be numbers in our proptypes
  */
  buoys: Array<NearbyStation> | [] | any;
}

const MapBuoyCards: React.FC<Props> = ({ buoys = [] }) => {
  const { width: deviceWidth } = useWindowSize();
  const isVerticalView = deviceWidth > config.tabletLargeWidth;

  return (
    <ul
      data-testid="map-buoy-cards"
      className={styles.mapBuoyCards}
      aria-label="List of buoys station within the map boundaries"
    >
      <BuoyVirtualList isVerticalView={isVerticalView} buoys={buoys} />
    </ul>
  );
};

export default memo(MapBuoyCards);
